import { FC, ReactNode } from 'react';

interface BrandCardSideContentProps {
  children: ReactNode;
}

const BrandCardSideContent: FC<BrandCardSideContentProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-md p-8">
        {children}
      </div>
    </div>
  );
};

export default BrandCardSideContent;
